<template>
  <transition name="fade">
    <v-card v-if="openFilter" class="grey lighten-3" height="110px" flat>
      <v-card-text>
        <v-layout row wrap class="pa-0 my-0">
          <slot scope="filterContent"></slot>
        </v-layout>
      </v-card-text>
    </v-card>
  </transition>
</template>

<script>
export default {
  props: {
    openFilter: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>